import { defaultTheme } from './theme/images/index';
import { CERTIFICATE_IMG_TYPE } from './theme/interface/index';
import { getTranslateThemeInfo } from './theme/dataflow/index';
import { getTranslateStudyThemeInfo, getThemeStyleType, getStudyThemeType, getDefaultThemeId, onTransformProgramTheme } from './theme/dataflow/common';
import { systemThemeTypeMap } from './theme/index';
import {
    ThemeBasicInfo,
    CertificateThemeList,
    CertificateTheme
} from './components/index';

const Certificate = {
    CertificateTheme,
    ThemeBasicInfo,
    defaultTheme,
    getDefaultThemeId,
    getStudyThemeType,
    systemThemeTypeMap,
    CertificateThemeList,
    getTranslateThemeInfo,
    getThemeStyleType,
    CERTIFICATE_IMG_TYPE,
    onTransformProgramTheme,
    getTranslateStudyThemeInfo,
};

export {
    Certificate,
}
